export const locale = {
  lang: "it",
  data: {
    MENU: {
      RECRUITMENT_STATISTICS: "Statistiche recruiter",
      COMMERCIAL_STATISTICS: "Statistiche commerciali",
    },
    STEPS_STATS: {
      SUITABLES: "Idonei",
      PROPOSED: "Proposti",
      CALLS: "Colloqui",
      KO: "Ko",
      OK: "Ok",
      BARGAININGS: "Contrattazioni",
      HIRED: "Assunti",
      TOTAL_INSERTED_CANDIDATES: "Totale candidati inseriti",
      TOTAL_INSERTED_REQUEST: "Totale richieste inserite",
    },
    COUNTER: "Contatore",
    GRAPH: "Grafico",
    ALERT: {
      ERROR_LOADING_STATS: "Errore nel caricamento delle statistiche",
      FROM_DATE_GREATER_THAN_TO_DATE: "La data di inizio non può essere maggiore della data di fine",
    },
    LOADING_CHART: "Caricamento grafico...",
    LOADING_COUNTER: "Caricamento contatore...",
    NO_STATISTICS_FOR_SELECTED_COMMERCIAL: "Nessuna statistica per il commerciale selezionato",
  },
};
